import { render, staticRenderFns } from "./ModalFormOrganizationPerson.vue?vue&type=template&id=2a6ff2d9&"
import script from "./ModalFormOrganizationPerson.vue?vue&type=script&lang=js&"
export * from "./ModalFormOrganizationPerson.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormOrganizationPerson.vue?vue&type=style&index=0&id=2a6ff2d9&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a6ff2d9')) {
      api.createRecord('2a6ff2d9', component.options)
    } else {
      api.reload('2a6ff2d9', component.options)
    }
    module.hot.accept("./ModalFormOrganizationPerson.vue?vue&type=template&id=2a6ff2d9&", function () {
      api.rerender('2a6ff2d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalFormOrganizationPerson.vue"
export default component.exports